import { createTypes, createAction } from "lib/action";

// *ดึงข้อมูล company list
const CHECK_DATA_TO_DLT_COMPANY_LIST = createTypes(
  "checkDataToDltCompanyList",
  "load"
);

// *ดึงข้อมูล log
const CHECK_DATA_TO_DLT_LOG = createTypes("checkDataToDltLog", "load");

// *check dlt
const CHECK_DATA_TO_DLT_CHECK_DLT = createTypes(
  "checkDataToDltCheckDlt",
  "load"
);

const CHECK_DATA_TO_DLT_MULTI_CHECK_DLT = createTypes(
  "checkDataToDltMultiCheckDlt",
  "load"
);
const UPDATE_CHECK_LIST = createTypes("updateDltCheckList", "update");

// *ดึงข้อมูล company list
const checkDataToDltCompanyList = {
  request: (data, loading) =>
    createAction(CHECK_DATA_TO_DLT_COMPANY_LIST.REQUEST, { data, loading }),
  success: (lists) =>
    createAction(CHECK_DATA_TO_DLT_COMPANY_LIST.SUCCESS, { lists }),
  failure: () => createAction(CHECK_DATA_TO_DLT_COMPANY_LIST.FAITLURE),
};

// *ดึงข้อมูล log
const checkDataToDltLog = {
  request: (data) => createAction(CHECK_DATA_TO_DLT_LOG.REQUEST, { data }),
  success: (lists) => createAction(CHECK_DATA_TO_DLT_LOG.SUCCESS, { lists }),
  failure: () => createAction(CHECK_DATA_TO_DLT_LOG.FAITLURE),
};

// *check dlt
const checkDataToDltCheckDlt = {
  request: (data) =>
    createAction(CHECK_DATA_TO_DLT_CHECK_DLT.REQUEST, { data }),
  success: (lists) =>
    createAction(CHECK_DATA_TO_DLT_CHECK_DLT.SUCCESS, { lists }),
  failure: () => createAction(CHECK_DATA_TO_DLT_CHECK_DLT.FAITLURE),
};

const checkDataToDltMultiCheckDlt = {
  request: (data) =>
    createAction(CHECK_DATA_TO_DLT_MULTI_CHECK_DLT.REQUEST, { data }),
  success: (lists) =>
    createAction(CHECK_DATA_TO_DLT_MULTI_CHECK_DLT.SUCCESS, { lists }),
  failure: () => createAction(CHECK_DATA_TO_DLT_MULTI_CHECK_DLT.FAITLURE),
};

const updateCheckList = {
  request: (data, callback = () => {}) =>
    createAction(UPDATE_CHECK_LIST.REQUEST, { data, callback }),
  success: (lists) => createAction(UPDATE_CHECK_LIST.SUCCESS, { lists }),
  failure: () => createAction(UPDATE_CHECK_LIST.FAITLURE),
};
export {
  CHECK_DATA_TO_DLT_COMPANY_LIST,
  checkDataToDltCompanyList,
  CHECK_DATA_TO_DLT_LOG,
  checkDataToDltLog,
  CHECK_DATA_TO_DLT_CHECK_DLT,
  checkDataToDltCheckDlt,
  CHECK_DATA_TO_DLT_MULTI_CHECK_DLT,
  checkDataToDltMultiCheckDlt,
  UPDATE_CHECK_LIST,
  updateCheckList,
};
